import { render } from "./App.vue?vue&type=template&id=1735b41a"
const script = {}

import exportComponent from "E:\\Zwen\\Project\\公司\\车妙净H5\\project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__